<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="save()">
                <div class="modal-header">
                    <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                    <h4 class="modal-title">{{ $t('it_is_so_sad') }} <i class="ti-face-sad"></i></h4>
                </div>
                <div class="modal_content">
                    <div class="alert alert_default">
                        <strong>{{ $t('_deals.sorry_lost_deal') }}! </strong>
                        {{ $t('_deals.what_else_to_help_next_time') }}
                    </div>
                    <div class="m_bottom_15" :class="{'has-error': errors['loss_reason_id']}">
                        <label>{{ $t('loss_reasons') }}</label>
                        <pml-select v-model="record.loss_reason_id" :options="lossReasons"></pml-select>
                        <span class="error" v-if="errors['loss_reason_id']">{{ errors['loss_reason_id'][0] }}</span>
                    </div>
                    <div class="m_bottom_15" :class="{'has-error': errors['description']}">
                        <label>{{ $t('description') }}</label>
                        <textarea v-model="record.description" class="form-control" rows="5" v-pml-autosize></textarea>
                        <span class="error" v-if="errors['description']">{{ errors['description'][0] }}</span>
                    </div>
                    <div v-if="scheduledRecords.length > 0" class="text-center">
                        <hr>
                        <h4><b>{{ $t('attention') }} <i class="fa fa-exclamation-triangle text-warning"></i></b></h4>
                        <p class="m-b-15"><b>{{ $t('_deals.we_noticed_scheduled_emails') }}</b></p>
                        <label>{{ $t('_deals.are_you_sure_delete_the_scheduled_emails') }}</label>
                        <div class="d_inline_b m-l-20">
                            <label class="label_radio m-r-20">
                                <input type="radio" name="teste" v-model="record.delete_schedule_emails" value="0" />
                                <span class="pull-left m-r-5"></span> {{ $t('no') }}
                            </label>
                            <label class="label_radio m-r-20">
                                <input type="radio" name="teste" v-model="record.delete_schedule_emails" value="1" />
                                <span class="pull-left m-r-5"></span> {{ $t('yes') }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="p-15 p-t-0">
                    <span class="btn btn-white" @click="goBack()">{{ $t('cancel') }}</span>
                    <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import RoutedModals from 'utils/mixins/routed-modals'
    import { trans } from 'utils/helpers/translation'
    import { cancel } from 'services/deals'
    import { mapGetters } from 'vuex'
    import { filter } from 'lodash'

    export default {
        name: 'DealCancel',
        mixins: [ RoutedModals ],
        data () {
            return {
                record: {
                    delete_schedule_emails: '0'
                },
                errors: [],
                isSaving: false
            }
        },
        computed: {
            ...mapGetters({
                'lossReasons': 'getActiveLossReasons',
                'emails': 'getDealEmails'
            }),
            scheduledRecords () {
                return filter(this.emails, function (o) {
                    return o.status === 'scheduled'
                }) || []
            }
        },
        methods: {
            save () {
                this.isSaving = true

                cancel(this.$route.params.id, this.record)
                    .then(() => {
                        Notify.success(trans('_notifications.success'))
                        this.goBack()
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/Lost.vue